import { Point } from 'geojson';
import { Resource } from './resource';

export interface CameraCommand {
    cameraCommandName: CAMERA_COMMAND_NAME;
    cameraImageMode: CAMERA_IMAGE_MODE;
    cameraPosition: Point;
    zoomLevel: number; // 0-100
}

export interface UAV_Command {
    commandName: UAV_COMMAND_NAME;
    uavPosition: Point;
}

export enum CAMERA_COMMAND_NAME {
    LOOK_TO_GROUND = 'LOOK_TO_GROUND',
    LOOK_TO_POI = 'POI',
    STOW = 'STOW'
}

export enum CAMERA_IMAGE_MODE {
    RGB = 'RGB',
    INFRARED = 'INFRARED'
}

export enum UAV_COMMAND_NAME {
    FLY_TO_POI = 'FLY_TO_POI',
    RETURN = 'RETURN',
    LAND = 'LAND',
}

export enum CAMERA_RECORDING {
    ON = 'ON',
    OFF = 'OFF'
}

export interface UAVCommand extends Resource {
    command?: UAV_Command;
    cameraCommand?: CameraCommand; // Just marking them as optional for easier updating
    cameraRecording: CAMERA_RECORDING;
    doSnapshot?: boolean;
}
